import styled from 'styled-components';
import { fontFamilies } from './Font';

const UnderlineSelected = styled.span`
  height: 20px;
  color: #000000;
  font-family: ${fontFamilies.regular}
  font-size: 15px;
  font-weight: 400;
  ${({ selected }) => (selected ? 'border-bottom: 3px solid #000;' : null)};
  line-height: 20px;
  cursor: pointer;
  text-decoration: none;
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
`;

export default UnderlineSelected;
